import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { QuerySortOrder } from "@/common/types/querySortOrder.type"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseAvailableCompanyBranchesProps<T> = {
  companyId: string | undefined;
  filters?: {
    search?: string;
    pageSize?: number;
  };
  sort?: {
    displayName: QuerySortOrder;
  },
  mapper?: (data: any) => T;
}

export const useAvailableCompanyBranches = <T,>({
  companyId,
  filters: { search = '', pageSize = 500 } = {},
  sort = { displayName: QuerySortOrder.Ascending },
  mapper = Mapper.default<T>(),
}: UseAvailableCompanyBranchesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['availableCompanyBranches', companyId, search, pageSize, sort.displayName],
    queryFn: () => {
      return privateAxios.get(`/client/companies/${companyId}/available_branches`, {
        params: {
          page_size: pageSize,
          search,
          'sort[display_name]': sort.displayName,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: !!companyId,
  });

  return { data, meta, ...rest };
}
